import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import CommentDto from 'dto/CommentDto';

import './comment-item.scss';
import Svg from 'common/Svg';
import { removeComment } from 'ducks/data/comments';
import { getName } from 'utils/userHelper';

export interface CommentItemProps {
	comment: CommentDto;
	exhibitId: number;
}

const CommentItem: React.FC<CommentItemProps> = ({ comment, exhibitId }) => {
	const dispatch = useDispatch();
	const { id, text, createdAt, user } = comment;

	const handleDelete = () => {
		if (confirm('Удалить комментарий?')) {
			dispatch(removeComment(id!, exhibitId, 'exhibit'));
		}
	};

	return (
		<div className="comment-item">
			<div className="comment-item__col big">
				<div className="comment-item__row">
					<div className="comment-item__col">{moment(createdAt).format('DD.MM.YYYY HH:mm:ss')}</div>
					<div className="comment-item__col">от пользователя </div>
					<Link to={`/museum/user/${user!.id!}`}>{getName(user)}</Link>
				</div>
				{text}
			</div>
			<div className="comment-item__col">
				<a onClick={handleDelete}>
					<Svg name="cross" />
				</a>
			</div>
		</div>
	);
};

export default CommentItem;
